import React, { useEffect, useState } from "react";
import styles from "./ComponentsStyles.module.css";

/**
 * Componente de transição com mensagem ou fallback para spinner.
 * @param {Object} props
 * @param {number} props.tempo - Tempo de exibição em ms.
 * @param {string} [props.mensagem] - Mensagem a ser exibida.
 * @param {Function} [props.onFim] - Callback ao fim da exibição.
 */
const TransicaoComLoading = ({ tempo = 2000, mensagem, onFim }) => {
  const [visivel, setVisivel] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisivel(false);
      if (onFim) onFim();
    }, tempo);
    return () => clearTimeout(timer);
  }, [tempo, onFim]);

  if (!visivel) return null;

  const mensagemFinal =
    typeof mensagem === "string" && mensagem.trim() !== ""
      ? mensagem
      : null;

  return (
    <div className={styles.overlay}>
      <div className={styles.loadingContainer}>
        <div className={styles.loadingText}>
          {mensagemFinal ? (
            <span>{mensagemFinal}</span>
          ) : (
            <>
              <div className={styles.spinner}></div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TransicaoComLoading;
